module.exports = __webpack_public_path__ + "static/media/cinematique.5ca88289.mp4";